import api from "./api";

const fetchAllRegions = ({ callback, params }) => {
  api({
    Method: "GET",
    Url: "/region",
    Params: params,
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const data = response?.data?.length !== 0 ? response?.data : [];
        callback(data);
      }
    },
  });
};

const fetchRegionalCongressman = ({ params, selectedCongress, callback }) => {
  const url = `/region/${params}/congressmen?congress=${selectedCongress}`;

  api({
    Url: url,
    Method: "GET",
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const data = response?.data?.length !== 0 ? response?.data : [];
        callback(data);
      }
    },
  });
};

const updateRowDetails = ({ formData, params, callback }) => {
  api({
    Method: "PUT",
    Url: `/recipient/${params}`,
    Data: formData,
    ResponseSuccessCallback: (response) => {
      if (response && response?.status === 200) {
        callback({
          isSuccess: true,
        });
      }
    },
    ResponseFailCallback: () => {
      callback({ isSuccess: false });
    },
  });
};

const fetchCongressmanProjects = ({ url, params, callback }) => {
  api({
    Method: "GET",
    Params: params,
    Url: url,
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const data = response?.data?.length !== 0 ? response?.data : [];

        callback(data);
      }
    },
  });
};

const fetchCongressmanDetails = ({ url, params, callback }) => {
  api({
    Url: url,
    Params: params,
    Method: "GET",
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const data = response?.data?.length !== 0 ? response?.data : {};
        callback(data);
      }
    },
  });
};

const fetchCommitteeDetails = ({ params, callback }) => {
  api({
    Method: "GET",
    Url: `/congressman/${params}/committees`,
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const data = response?.data?.length !== 0 ? response?.data : {};
        callback(data);
      }
    },
  });
};

const fetchComments = ({ headers, params, callback }) => {
  api({
    Method: "GET",
    Headers: headers,
    Url: `/recipient/${params}/comments`,
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const data = response?.data?.length !== 0 ? response?.data : [];
        callback(data);
      }
    },
  });
};

const fetchAgencyBudgetAllocation = ({ params, callback }) => {
  const { cong, agency } = params;

  api({
    Method: "GET",
    Url: `/congressman/${cong}/allocatedBudget/${agency}`,
    Params: params,
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        callback(response.data);
      }
    },
  });
};

const fetchRegions = ({ callback }) => {
  api({
    Method: "GET",
    Url: "/region",
    ResponseSuccessCallback: (response) => {
      if (response && response?.status === 200) {
        const { data } = response;
        callback(data);
      }
    },
  });
};

const fetchDistricts = ({ callback }) => {
  api({
    Method: "GET",
    Url: "/district",
    ResponseSuccessCallback: (response) => {
      if (response && response?.status === 200) {
        const { data } = response;
        callback(data);
      }
    },
  });
};

const editCongDetails = ({ url, formData, callback }) => {
  api({
    Method: "PUT",
    Url: url,
    Data: formData,
    ResponseSuccessCallback: (response) => {
      if (response && response.status === 200) {
        callback({ isSuccess: true });
      }
    },
    ResponseFailCallback: () => {
      callback({ isSuccess: false });
    },
  });
};

const deleteCongressman = ({ param, callback }) => {
  api({
    Url: `/congressman/${param}`,
    Method: "DELETE",
    ResponseSuccessCallback: (response) => {
      if (response && response?.status === 200) {
        callback({ isSuccess: true });
      }
    },
    ResponseFailCallback: () => {
      callback({ isSuccess: false });
    },
  });
};

const addCongressman = ({ formData, callback }) => {
  api({
    Method: "POST",
    Url: "/congressman",
    Data: formData,
    ResponseSuccessCallback: (response) => {
      if (response && response.status === 200) {
        callback({
          isSuccess: true,
          msg: response.data,
        });
      } else {
        callback({
          isSuccess: false,
          msg: response.data,
        });
      }
    },
    ResponseFailCallback: (err) => {
      callback({
        isSuccess: false,
        msg: err.response.data,
      });
    },
  });
};

const fetchAllUpdateLogs = ({ param, callback }) => {
  api({
    Method: "GET",
    Url: `/request-log?method=PUT&table=Congressmen&referenceId=${param}`,
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const data = response?.data?.length ? response?.data : [];
        callback(data);
      }
    },
  });
};

const fetchAllCongressmen = ({ callback }) => {
  api({
    Method: "GET",
    Url: "/congressman/?type=getall",
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const data = response?.data?.length ? response?.data : [];
        callback(data);
      }
    },
  });
};

export {
  fetchAllRegions,
  fetchRegionalCongressman,
  updateRowDetails,
  fetchCongressmanProjects,
  fetchCongressmanDetails,
  fetchCommitteeDetails,
  fetchComments,
  fetchAgencyBudgetAllocation,
  fetchRegions,
  fetchDistricts,
  editCongDetails,
  deleteCongressman,
  addCongressman,
  fetchAllUpdateLogs,
  fetchAllCongressmen,
};
